import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
 
import "../assets/css/styles.table.css"
import '../assets/additional-css/styles.css';
 

import AxiosFetchData from '../pages/AxiosFetchData';
import Highcharts from 'highcharts';
import ApexChart from 'apexcharts';
 
import Helper from '../pages/Helper';
 
export const useExecutiveDashboardHook = () =>{
    const [projectCount, setProjectCount] = useState(0);
  const [clientCount, setClientCount] = useState(0);
  const [anggaran, setAnggaran] = useState(0);
  const [taskCount, setTaskCount] = useState(0);
  const [taskSelesaiCount, setTaskSelesaiCount] = useState(0);
  const [jamRencana, setJamRencana] = useState(0);
  const Navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [rowNumber, setRowNumber] = useState([]);
  const [chart2, setChart2] = useState({});
  const [riskMatrix, setRiskMatrix] = useState({});
  const [message, setmessage] = useState('')
  const [tipe, settipe] = useState('')
  const [chartData, setChartData] = useState([])
  const [page, setPage] = useState(0)
  const [pageChart7, setPageChart7] = useState(0)
  const [pageChart8, setPageChart8] = useState(0)
  const [pageChart14, setPageChart14] = useState(0)
  const [roleAccess, setRoleAccess] = useState('');
  
  //var temp = []
 //var arr = [];
useEffect(() => {
  //  arr = [1,1,4,5];
  
    GetData();
   // document.getElementById("btnRefresh").click();
}, []);


const refreshChart = () => {
    GetData();
}

const GetChart1 = async (data) => {
  
    Highcharts.chart('chart', {
        chart: {
            type: 'pie',
            height: 280,
           // width: 100
            custom: {},
            events: {
                render() {
                    const chart = this,
                        series = chart.series[0];
                    let customLabel = chart.options.chart.custom.label;
                  //  const proses = data.data.chart1.find((o) => o.s)
                   // const sum = data.data.chart1.reduce((acc, o) => acc + parseInt(o.y), 0);
                     
                    if (!customLabel) {
                        customLabel = chart.options.chart.custom.label =
                            // chart.renderer.label(data.data.taskProses + ' Dari '  +
                            //      data.data.taskCount + ' Tugas<br/>' + ' Dalam Proses'
                            // )
                            chart.renderer.label( 
                              data.data.taskCount + ' Tugas<br/>'  
                         )
                                .css({
                                    color: '#000',
                                    textAnchor: 'middle',
                                    fontSize: '8px',
                                })
                                .add();
                    }
    
                    const x = series.center[0] + chart.plotLeft,
                        y = series.center[1] + chart.plotTop -
                        (customLabel.attr('height') / 2);
    
                    customLabel.attr({
                        x,
                        y
                    });
                    // Set font size based on chart diameter
                    customLabel.css({
                        fontSize: `${series.center[2] / 12}px`
                    });
                }
            }
        },
        // accessibility: {
        //     point: {
        //         valueSuffix: '%'
        //     }
        // },
        title: {
            text: null
        },
        
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y:.0f}</b>'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                borderRadius: 8,
                dataLabels: [{
                    enabled: true,
                    distance: 20,
                    format: '{point.name}'
                }, {
                    enabled: true,
                    distance: -15,
                    //format: '{point.percentage:.0f}%',
                     format: '{point.y:.0f}',
                    style: {
                        fontSize: '0.9em'
                    }
                }],
                showInLegend: true
            }
        },
        series: [{
         //   name: 'Registrations',
            colorByPoint: true,
            innerSize: '75%',
            data:data.data.chart1
        }]
    });
}

const GetChart2 = async (data) => {
     
     var name = data.map((item) => item.name);
     var y = data.map((item) => item.y);
     const sum = data.reduce((acc, o) => acc + parseInt(o.y), 0);
    var options = {
        series: y,
        chart: {
        height: 350,
        type: 'radialBar',
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: '30%',
            background: 'transparent',
            image: undefined,
          },
          dataLabels: {
            name: {
              show: true,
            },
            value: {
              show: true,
            },
            total: {
                show: true,
                label: sum  ,
                formatter: function (w) {
                  
                  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                   return 'Project'
                }
              }
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            offsetX: -8,
            fontSize: '16px',
            formatter: function(seriesName, opts) {
              return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + " project"
            },
          },
        }
      },
      colors: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
      labels: name,
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
              show: true,
          }
        }
      }]
      };

      document.querySelector("#chart2").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart2"), options);
     
      chart.render();
      // setChart2(state);
}
 
const GetChart3 = async (data) => {
    var name = data.map((item) => item.name);
    var data = data.map((item) => item.data);

    var options = {
        series: [{
        data: data
      }],
        chart: {
        type: 'bar',
        height: 250,
        width: "100%",
        toolbar: {
            show: false
          }
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: name,
      }
      };
      document.querySelector("#chart3").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart3"), options);
      chart.render();
}

const GetChart4 = async (data) => {
    // console.log(data)
     Highcharts.chart('chart4', {
         chart: {
             type: 'pie',
             height: 280,
             width: 280,
             custom: {},
             events: {
                 render() {
                     const chart = this,
                         series = chart.series[0];
                     let customLabel = chart.options.chart.custom.label;
                     const taskSelesaiPercentage =  Math.round((data.find((element) => element.name == "Selesai").y /  (data.find((element) => element.name == "Selesai").y + data.find((element) => element.name == "Tertunda").y)) * 100) + "%";
                    
                     if (!customLabel) {
                         customLabel = chart.options.chart.custom.label =
                             chart.renderer.label(taskSelesaiPercentage
                             )
                                 .css({
                                     color: '#000',
                                     textAnchor: 'middle',
                                     fontSize: '8px',
                                 })
                                 .add();
                     }
     
                     const x = series.center[0] + chart.plotLeft,
                         y = series.center[1] + chart.plotTop -
                         (customLabel.attr('height') / 2);
     
                     customLabel.attr({
                         x,
                         y
                     });
                     // Set font size based on chart diameter
                     customLabel.css({
                         fontSize: `${series.center[2] / 12}px`
                     });
                 }
             }
         },
         // accessibility: {
         //     point: {
         //         valueSuffix: '%'
         //     }
         // },
         title: {
             text: null
         },
         
         tooltip: {
             pointFormat: '{point.name}: <b>{point.y:.0f}</b>'
         },
         legend: {
             enabled: false
         },
         plotOptions: {
             series: {
                 allowPointSelect: true,
                 cursor: 'pointer',
                 borderRadius: 8,
                 dataLabels: [{
                     enabled: true,
                     distance: 20,
                     format: '{point.name}'
                 }, {
                     enabled: true,
                     distance: -15,
                     //format: '{point.percentage:.0f}%',
                      format: '{point.y:.0f}',
                     style: {
                         fontSize: '0.9em'
                     }
                 }],
                 showInLegend: true
             }
         },
         series: [{
          //   name: 'Registrations',
             colorByPoint: true,
             innerSize: '75%',
             data:data 
         }]
     });
 }

 const GetChart5 = async (data) => {
   //  console.log(data);
    var options = {
        series: [
        {
          data: data
        }
      ],
        chart: {
            height: 250,
            width:"100%",
            type: 'rangeBar',
            toolbar: {
                show: true,
                tools:{
                  download:false // <== line to add
                }
              }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          dataLabels: {
            hideOverflowingLabels: false
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          var label = opts.w.globals.labels[opts.dataPointIndex]
        
          return label  
        },
        style: {
          colors: ['#f3f4f5', '#fff']
        }
      },
      xaxis: {
        type: 'datetime',
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            colors: [],
            fontSize: '6px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 500,
           // cssClass: 'apexcharts-xaxis-label',
        },
        rotate: 15,
        rotateAlways: false,
        hideOverlappingLabels: true,
        }
      },
      grid: {
        row: {
          colors: ['#f3f4f5', '#fff'],
          opacity: 1
        }
      }
      };
      document.querySelector("#chart5").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart5"), options);
      chart.render();
 }

 const GetChart6 = async (data) => {
    var name = data.map((item) => item.nama_client);
    var data = data.map((item) => item.workload);

    var options = {
        series: [{
        data: data
      }],
        chart: {
        type: 'bar',
        height: 250,
        width: "100%",
        toolbar: {
            show: false
          }
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: name,
      }
      };

      document.querySelector("#chart6").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart6"), options);
      chart.render();
}

const GetChart7 = async (data)  =>{
    var faktur = data.map((item) => item.faktur);
    var anggaranTersisa = data.map((item) => item.anggaran_tersisa);
    var namaProjek = data.map((item) => item.nama_project);

    var options = {
        series: [{
            name: 'Invoices',
            data: faktur
        }, {
            name: 'Tersisa',
            data: anggaranTersisa
        }],
        chart: {
          type: 'bar',
          height: 260,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false,
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end', // 'around', 'end'
          borderRadiusWhenStacked: 'last', // 'all', 'last'
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '10',
                fontWeight: 900
              }
            }
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return Helper.formatAsCurrency(val);
        },
        offsetY: -20,
        style: {
          fontSize: '10',
          colors: ["#304758"]
        }
      },
      xaxis: {
       // type: 'datetime',
        categories: namaProjek,
        labels: {
          style: {
            colors: [],
            fontSize: '8px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 500,
           // cssClass: 'apexcharts-xaxis-label',
        },
        rotate: -20,
        rotateAlways: false,
        hideOverlappingLabels: true,
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
          formatter: function (val) {
            return Helper.formatAsCurrency(val) ;
          }
        }
      
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
      };

      document.querySelector("#chart7").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart7"), options);
      chart.render();
}

const GetChart8 = async (data)  =>{
    var pengeluaran = data.map((item) => item.anggaran_tersisa);
    
    var namaProjek = data.map((item) => item.subject);

    var options = {
        series: [{
            name: 'Pengeluaran',
            data: pengeluaran
        } ],
        chart: {
        type: 'bar',
        height: 280,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end', // 'around', 'end'
          borderRadiusWhenStacked: 'last', // 'all', 'last'
          dataLabels: {
            total: {
              enabled: true, // //
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return Helper.formatAsCurrency(val);
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#304758"]
        }
      },
      xaxis: {
       // type: 'datetime',
        categories: namaProjek,
        labels: {
          style: {
            colors: [],
            fontSize: '8px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 500,
           // cssClass: 'apexcharts-xaxis-label',
        },
        rotate: -20,
        rotateAlways: false,
        hideOverlappingLabels: true,
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
          formatter: function (val) {
            return Helper.formatAsCurrency(val) ;
          }
        }
      
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
      };

      document.querySelector("#chart8").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart8"), options);
      chart.render();
}

const GetChart9 = async (data)  =>{
    var jamRencana = data.map((item) => item.jam_rencana);
    var jamSebenranya = data.map((item) => item.jam_sebenernya);
    var namaProjek = data.map((item) => item.nama_project);

    var options = {
        series: [{
            name: 'Jam Rencana',
            data: jamRencana
        }, {
            name: 'Jam Sebenarnya',
            data: jamSebenranya
        }],
        chart: {
        type: 'bar',
        height: 280,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end', // 'around', 'end'
          borderRadiusWhenStacked: 'last', // 'all', 'last'
          dataLabels: {
            total: {
              enabled: false, //
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
      xaxis: {
       // type: 'datetime',
        categories: namaProjek,
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
      };

      document.querySelector("#chart9").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart9"), options);
      chart.render();
}

const GetChart10 = async (data) => {
  
    Highcharts.chart('chart10', {
        chart: {
            type: 'pie',
            height: 280,
           width: 300,
            custom: {},
            events: {
                render() {
                    const chart = this,
                        series = chart.series[0];
                    let customLabel = chart.options.chart.custom.label;
                  //  const proses = data.data.chart1.find((o) => o.s)
                     const sum = data.reduce((acc, o) => acc + parseInt(o.y), 0);
                     
                    if (!customLabel) {
                        customLabel = chart.options.chart.custom.label =
                            chart.renderer.label('Total Risiko/Isu' + '<br/>' +  sum)
                                .css({
                                    color: '#000',
                                    textAnchor: 'middle',
                                    fontSize: '8px',
                                })
                                .add();
                    }
    
                    const x = series.center[0] + chart.plotLeft,
                        y = series.center[1] + chart.plotTop -
                        (customLabel.attr('height') / 2);
    
                    customLabel.attr({
                        x,
                        y
                    });
                    // Set font size based on chart diameter
                    customLabel.css({
                        fontSize: `${series.center[2] / 12}px`
                    });
                }
            }
        },
        // accessibility: {
        //     point: {
        //         valueSuffix: '%'
        //     }
        // },
        title: {
            text: null
        },
        
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y:.0f}</b>'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                borderRadius: 8,
                dataLabels: [{
                    enabled: true,
                    distance: 20,
                    format: '{point.name}'
                }, {
                    enabled: true,
                    distance: -15,
                    //format: '{point.percentage:.0f}%',
                     format: '{point.y:.0f}',
                    style: {
                        fontSize: '0.9em'
                    }
                }],
                showInLegend: true
            }
        },
        series: [{
         //   name: 'Registrations',
            colorByPoint: true,
            innerSize: '75%',
            data:data
        }]
    });
}

const GetChart11 = async (data) => {
    var name = data.map((item) => item.name);
    var data = data.map((item) => item.data);

    var options = {
        series: [{
        data: data
      }],
        chart: {
        type: 'bar',
        height: 250,
        width: "100%",
        toolbar: {
            show: false
          }
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: name,
      }
      };
      document.querySelector("#chart11").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart11"), options);
      chart.render();
}

const GetChart12 = async (data)  =>{
    var pengeluaran = data.map((item) => item.data);
    
    var namaProjek = data.map((item) => item.name);

    var options = {
        series: [{
            name: 'Level Resiko',
            data: pengeluaran
        } ],
        chart: {
        type: 'bar',
        height: 250,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end', // 'around', 'end'
          borderRadiusWhenStacked: 'last', // 'all', 'last'
          dataLabels: {
            total: {
              enabled: true, // //
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
      xaxis: {
       // type: 'datetime',
        categories: namaProjek,
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
      };

      document.querySelector("#chart12").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart12"), options);
      chart.render();
}

const GetChart13 = async (data)  =>{
    var pengeluaran = data.map((item) => item.data);
    
    var namaProjek = data.map((item) => item.name);

    var options = {
        series: [{
            name: 'Resiko',
            data: pengeluaran
        } ],
        chart: {
        type: 'bar',
        height: 250,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end', // 'around', 'end'
          borderRadiusWhenStacked: 'last', // 'all', 'last'
          dataLabels: {
            total: {
              enabled: true, // //
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
      xaxis: {
       // type: 'datetime',
        categories: namaProjek,
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
      };

      document.querySelector("#chart13").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart13"), options);
      chart.render();
}

const GetChart14 = async (data)  =>{
  var pengeluaran = data.map((item) => item.anggaran_tersisa);
  
  var namaProjek = data.map((item) => item.subject);

  var options = {
      series: [{
          name: 'Pengeluaran',
          data: pengeluaran
      } ],
      chart: {
      type: 'bar',
      height: 280,
      stacked: true,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      
    },
    responsive: [{
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          offsetX: -10,
          offsetY: 0
        }
      }
    }],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        borderRadiusApplication: 'end', // 'around', 'end'
        borderRadiusWhenStacked: 'last', // 'all', 'last'
        dataLabels: {
          total: {
            enabled: true, // //
            style: {
              fontSize: '12px',
              fontWeight: 900
            }
          }
        }
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return Helper.formatAsCurrency(val);
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ["#304758"]
      }
    },
    xaxis: {
     // type: 'datetime',
      categories: namaProjek,
      labels: {
        style: {
          colors: [],
          fontSize: '8px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 500,
         // cssClass: 'apexcharts-xaxis-label',
      },
      rotate: -20,
      rotateAlways: false,
      hideOverlappingLabels: true,
      }
       
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: true,
        formatter: function (val) {
          return Helper.formatAsCurrency(val) ;
        }
      }
    
    },
    legend: {
      position: 'right',
      offsetY: 40
    },
    fill: {
      opacity: 1
    }
    };

    document.querySelector("#chart14").innerHTML = "";
    var chart = new ApexChart(document.querySelector("#chart14"), options);
    chart.render();
}

const GetData = async () => {
  try{
    const response = await AxiosFetchData.get("GetData").refreshToken(Navigate,"executivedashboard");
    //  console.log(response.data.clientCount);
     if(response){
      setRoleAccess(response.roleaccess)
      setChartData(response.data)
     setClientCount(response.data.clientCount);
     setProjectCount(response.data.projectCount);
     setAnggaran(response.data.anggaran);
     setTaskCount(response.data.taskCount);
     setJamRencana(response.data.jamRencana);
    // setChart2(response.data.chart2);
     setTaskSelesaiCount(response.data.taskSelesai);
     await GetChart1(response);
     await GetChart2(response.data.chart2);
     await GetChart3(response.data.chart3)

     var temp1 = [...response.data.chart7]
     await GetChart7(temp1.splice(pageChart7,5))
      //GetChart7(response.data.chart7)
      var temp2 = [...response.data.chart8]
   
      await GetChart8(temp2.splice(pageChart8,5))
     
      var temp3 = [...response.data.chart14]
   
     await GetChart14(temp3.splice(pageChart14,5))

     var data = [{
             name : "Selesai",
             y: response.data.taskSelesai
         },{
             name : "Tertunda",
             y: response.data.taskTertunda
         }]
  
         await  GetChart4(data);
    //  GetChart5(response.data.chart5.splice(0,10));
     var temp = [...response.data.chart5]
     await GetChart5(temp.splice(page,10));

 
     //setRiskMatrix(response.data.riskMatrix);
     }
      
    
  }catch(err){
    
    setmessage(err.message);
    settipe('errorlog')
  }
    
}

const Chart5Paging =  async  (tipe, pageNumber) => {
  if(pageNumber < 0){
      return;
  }

  var temp = [...chartData.chart5.toSorted()];
   
  if((pageNumber * 10) >= temp.length){
    return;
  }
   
  setPage(pageNumber)
   
  await  GetChart5(temp.splice((pageNumber * 10)  , 10));
   
}

const Chart7Paging =  async (pageNumber) => {
  if(pageNumber < 0){
      return;
  }

  var temp = [...chartData.chart7.toSorted()];
   
  if((pageNumber * 5) >= temp.length){
    return;
  }
   
  setPageChart7(pageNumber)
   
  await GetChart7(temp.splice((pageNumber * 5)  , 5));
   
}

const Chart8Paging =  async (pageNumber) => {
  if(pageNumber < 0){
      return;
  }

  var temp = [...chartData.chart8.toSorted()];
   
  if((pageNumber * 5) >= temp.length){
    return;
  }
   
  setPageChart8(pageNumber)
   
  await GetChart8(temp.splice((pageNumber * 5)  , 5));
   
}
 
const Chart14Paging =  async (pageNumber) => {
  if(pageNumber < 0){
      return;
  }

  var temp = [...chartData.chart14.toSorted()];
   
  if((pageNumber * 5) >= temp.length){
    return;
  }
   
  setPageChart14(pageNumber)
   
  await GetChart14(temp.splice((pageNumber * 5)  , 5));
   
}
    return {message,setmessage,tipe,settipe,refreshChart,projectCount,clientCount,anggaran,taskCount,taskSelesaiCount,
            Chart5Paging,page,Chart7Paging,pageChart7,Chart8Paging,pageChart8,Chart14Paging,pageChart14
    }
}